import React from 'react';
import { IconButton, Badge, Tooltip, Box, CircularProgress } from '@mui/material';
import { WorkHistory as WorkHistoryIcon } from '@mui/icons-material';
import { useJobs } from '../contexts/JobsContext';

export const JobsButton: React.FC = () => {
  const { runningJobs, showJobsPanel, setShowJobsPanel, isLoading } = useJobs();

  const handleClick = () => {
    setShowJobsPanel(!showJobsPanel);
  };

  return (
    <Tooltip title="Export Jobs">
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={runningJobs.length} color="primary">
          <Box sx={{ position: 'relative', display: 'flex' }}>
            <WorkHistoryIcon />
            {isLoading && runningJobs.length > 0 && (
              <CircularProgress
                size={40}
                sx={{
                  position: 'absolute',
                  top: -8,
                  left: -8,
                  zIndex: 1,
                }}
                thickness={2}
              />
            )}
          </Box>
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
